<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入用户id"
        v-model="params.uid"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入id"
        v-model="params.id"
        clearable
        size="small"
        class="param-input"
        style="width: 280px"
      ></el-input>
      <el-select
        placeholder="请选择激活状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select placeholder="请选择模版" clearable size="small" v-model="params.vidId">
        <el-option :label="item.title" :value="item.id" v-for="item in faceModList" :key="item.id"></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="picture"
        label="换脸人物图"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.picture || !scope.row.picture.length"
            >未知</span
          >
          <div
            v-else
            class="picturePreview"
          >
            <decrypt-img
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item, i) in scope.row.picture"
              :key="i"
            ></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="modTitle"
        label="模版标题"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.modTitle || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="modUrl"
        label="模版视频"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.modUrl, 'video', scope.row)"
            v-if="scope.row.modUrl"
          >
          </i>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="生成视频" align="center" width="120">
        <template slot-scope="scope">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.url, 'video', scope.row)"
            v-if="scope.row.url"
          >
          </i>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="激活状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">已完成</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status == 2">已提交</el-tag>
          <el-tag type="info" v-else-if="scope.row.status == 0">未完成</el-tag>
          <el-tag v-else-if="scope.row.status == -1">已退款</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="原因"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="价格" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.coin + scope.row.incomeCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operator"
        label="审核人"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.operator || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="220"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            icon="el-icon-edit"
            @click="pass(scope.row)"
            v-if="scope.row.status == 0"
            >自动处理</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            v-if="scope.row.status == 0"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-refresh"
            @click="openReset(scope.row)"
            v-if="scope.row.status != 0"
            >状态重置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="530px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="140px" ref="form">
        <el-form-item label="上传视频:">
          <!--视频分片上传-->
          <uploader
            :options="options"
            class="uploader-example"
            ref="uploader"
            @file-added="fileAdd"
            @file-success="onFileSuccess"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :attrs="attrs">上传视频</uploader-btn>
            </uploader-drop>
            <uploader-list></uploader-list>
          </uploader>
        </el-form-item>
        <el-form-item label="状态" prop="status" style="width: 400px">
          <el-select v-model="form.status">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原因:" prop="remark" v-if="form.status == -1">
          <el-input
            type="textarea"
            v-model="form.remark"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import local from "@/utils/localStroage.js";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewVideo from "./components/preview-video";
import PreviewPicture from "./components/previewPicture";
export default {
  components: {
    PreviewVideo,
    PreviewPicture,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      faceModList: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined, // 状态
        vidId: "", // 视频模版id
      },
      statuses: [
        {
          label: "未完成",
          value: 0,
        },
        {
          label: "已完成",
          value: 1,
        },
        {
          label: "已提交",
          value: 2,
        },
        {
          label: "已退款",
          value: -1,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        url: "", // 视频资源地址
        remark: "", // 备注
        status: undefined, // 状态，0 未激活 1 激活
      },
      dataIds: [],
      batchUpdateDialog: false,
      batchStatus: 0,
      // 用户头像上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      imgUrl: baseConfig.imgUrl,
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], // 接受文件类型
      },
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", // 上传地址
        testChunks: false, // 是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", // 文件名参数，默认为file
        query: this.uploadQuery, // 额外参数
        singleFile: true, // 单文件上传
        chunkSize: 2048000, // 分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  created() {
    this.getList();
    this.getFaceModList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getChangeFaceList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pass(row) {
      const req = {
        id: row.id,
        title: row.modTitle,
        status: 2,
      };
      API.updChangeFaceList(req).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "通过成功",
          });
          this.handleClose();
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: res.msg || "通过失败",
          });
        }
      });
    },
    // 上传成功回掉
    successCallback(res) {
      this.form.cover = res.data.coverImg;
    },
    // 视频上传成功时回调函数
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response);
      this.form.url = res.data.sourceURL;
      //通知文件服务器, 上传完成
      API.uploadSuccess({ id: res.data.sourceID })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("通知失败！");
          }
        })
        .catch(() => {
          this.$message.error("通知异常！");
        });
    },
    // 视频上传选中时
    fileAdd() {
      this.generateTaskId();
    },
    // 图集预览
    previewPicture(pictureArr) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr);
    },
    // 定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    // 视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId),
      };
    },
    // 视频查看
    checkMedia(url, type, data) {
      this.$refs.previewVideo.open(url, type, data);
    },
    // 新增标签配置
    addAndEdit(param) {
      this.dialogTitle = "编辑";
      // 把数据回显给表单
      this.form.id = param.id;
      this.form.status = param.status;
      this.dialogVisible = true; // 打开编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updChangeFaceList(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updChangeFaceList(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPrompt(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openReset(row) {
      this.$confirm("确认重置该订单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let req = {
            id: row.id,
            status: 0,
          };
          API.updChangeFaceList(req).then((res) => {
            if (res.code == 200) {
              this.getList();
              this.$message({
                type: "success",
                message: "重置成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg || "重置失败!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.url = "";
      this.form.status = undefined;
      this.form.remark = "";
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.dataIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.dataIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      const tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.dataIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.dataIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.dataIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.dataIds = this.dataIds.concat(objArr);
      const tempDatas = new Set(this.dataIds);
      this.dataIds = Array.from(tempDatas);
    },
    //查询AI换脸模版
    getFaceModList() {
      var params = {
        pageNumber: 1,
        pageSize: 30,
      };
      API.getChangeFaceModList(params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.faceModList = res.data.list;
          } else {
            this.faceModList = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.picturePreview {
  max-width: 400px;
  display: flex;
}
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
